module.exports = __webpack_public_path__ + "../resources/img/@temp_chart_5.8aab5a4b.jpg";